import { render, staticRenderFns } from "./DiscoveryTableSortingSingle.vue?vue&type=template&id=a88c5310&scoped=true&"
import script from "./DiscoveryTableSortingSingle.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTableSortingSingle.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryTableSortingSingle.vue?vue&type=style&index=0&id=a88c5310&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88c5310",
  null
  
)

export default component.exports